var map = {
	"./artmuseum.jpg": 8165,
	"./goldenpavilion.jpg": 3820,
	"./goodperson.jpg": 9410,
	"./imaybewrong.jpg": 14,
	"./twoyearsinthestates.jpg": 4572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2329;